export default __webpack_public_path__ + "static/media/Shirt2.f9f7f3a3.jpeg";